import { useQuery } from '@tanstack/react-query';

import { fetchTasksCount } from './api';
import { TASK_COUNTS_BY_STATUS_QUERY_KEY_ROOT, TASKS_AFTER_DATETIME } from './constants';
import { useIsTaskNotificationEnabledPath } from './useIsTaskNotificationEnabledPath';
import { useTaskManagementEnabled } from './useTaskManagementEnabled';

export const useGetTasksCountQuery = (warehouseId?: string) => {
  const isTaskEnabled = useTaskManagementEnabled(warehouseId);
  const isTaskNotificationEnabledPath = useIsTaskNotificationEnabledPath();

  const enabled = !!warehouseId && isTaskEnabled && isTaskNotificationEnabledPath;

  const { data: tasksCount } = useQuery({
    queryKey: [TASK_COUNTS_BY_STATUS_QUERY_KEY_ROOT, { warehouseId }],
    queryFn: () =>
      fetchTasksCount({
        warehouseId: warehouseId!,
        createdAfter: TASKS_AFTER_DATETIME,
      }),
    enabled,
    refetchInterval: 5 * 60 * 1000, // 5 minutes
    staleTime: 30 * 1000, // 30 seconds
  });

  return tasksCount;
};
